const HealthInsuranceFormTranslations = {
    en: {
        labels: {
            title: 'Health Insurance Requirement Analysis',
            description: 'Please provide your details for health insurance recommendation.',
            form_timestamp: 'Timestamp',
            email: 'Email Address',
            name: 'Full Name', // Corrected: Match state property
            mobile: 'Mobile Number', // Corrected: Match state property
            city_of_residence: 'City of Residence', // Corrected: Match state property
            tier_city: 'City Tier', // NEW LABEL
            age: 'Age', // Changed for clarity
            numberOfMembers: 'Number of Family Members (Including you, max 5)', // Added clarity
            eldestMemberAge: 'Age of Eldest Family Member',
            preExistingDiseases: 'Do you or any family members have Pre-Existing Diseases?',
            majorSurgery: 'Have you or any family members undergone Major Surgery in the last 12 months?',
            existingInsurance: 'Do you have existing health insurance?',
            currentCoverage: 'Current Coverage Amount (Minimum ₹3 Lakhs)', // Added currency and min value
            portPolicy: 'Planning to port your policy to another provider?',
            submit: 'Submit',
            selectOption: 'Select an option',

            // Additional labels
            personalDetails: 'Personal Details',
            familyDetails: 'Family Details',
            medicalHistory: 'Medical History',
            insuranceDetails: 'Insurance Details',
            recommendation: 'Recommended Coverage',
            submitSuccess: 'Form submitted successfully! We will contact you soon.' // Added success message
        },
        placeholders: {
            email: 'Enter your email address (e.g., example@domain.com)',
            name: 'Enter your full name',
            mobile: 'Enter your 10-digit mobile number',
            city_of_residence: 'Select your city', // Changed to reflect select input
            age: 'e.g., 40',
            numberOfMembers: 'e.g., 3',
            eldestMemberAge: 'e.g., 65',
            currentCoverage: 'e.g., 500000',
        },
        errors: {
            invalidEmail: 'Please enter a valid email address (e.g., example@domain.com).',
            emailRequired: 'Email is required.',
            nameRequired: 'Full name is required.',
            mobileRequired: 'Mobile number is required.',
            invalidMobile: 'Please enter a valid 10-digit mobile number.',
            cityRequired: 'City of residence is required.',
            ageRequired: 'Your age is required.',
            invalidAge: 'You must be at least 18 years old to apply.',
            membersRequired: 'Number of family members is required.',
            invalidMembers: 'Number of family members must be between 1 and 5.',
            eldestAgeRequired: 'Eldest member\'s age is required.',
            // Added specific error for eldest member age logic
            eldestAgeValidation: "Eldest member's age cannot be less than your age.",
            preExistingRequired: 'Please select an option for pre-existing diseases.',
            surgeryRequired: 'Please select an option for major surgery history.',
            insuranceRequired: 'Please specify if you have existing health insurance.',
            coverageRequired: 'Current coverage amount is required if you have existing insurance.',
            invalidCoverage: 'Minimum coverage amount is ₹3,00,000.',
            portPolicyRequired: 'Please specify if you are planning to port your policy.',
            // Added a generic submission error for feedback
            submissionError: 'There was an issue submitting your form. Please try again later.'
        },
        data: {
            yesNoOptions: [
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' }
            ],

            cityOptions : [
                { value: 'Ahmedabad', label: 'Ahmedabad' },
                { value: 'Bengaluru', label: 'Bengaluru' },
                { value: 'Bhopal', label: 'Bhopal' },
                { value: 'Bhubaneswar', label: 'Bhubaneswar' },
                { value: 'Chandigarh', label: 'Chandigarh' },
                { value: 'Chennai', label: 'Chennai' },
                { value: 'Coimbatore', label: 'Coimbatore' },
                { value: 'Dehradun', label: 'Dehradun' },
                { value: 'Delhi', label: 'Delhi' },
                { value: 'Faridabad', label: 'Faridabad' },
                { value: 'Ghaziabad', label: 'Ghaziabad' },
                { value: 'Goa', label: 'Goa' },
                { value: 'Guwahati', label: 'Guwahati' },
                { value: 'Hyderabad', label: 'Hyderabad' },
                { value: 'Indore', label: 'Indore' },
                { value: 'Jaipur', label: 'Jaipur' },
                { value: 'Jamshedpur', label: 'Jamshedpur' },
                { value: 'Kanpur', label: 'Kanpur' },
                { value: 'Kochi', label: 'Kochi' },
                { value: 'Kolkata', label: 'Kolkata' },
                { value: 'Lucknow', label: 'Lucknow' },
                { value: 'Ludhiana', label: 'Ludhiana' },
                { value: 'Madurai', label: 'Madurai' },
                { value: 'Mangalore', label: 'Mangalore' },
                { value: 'Mumbai', label: 'Mumbai' },
                { value: 'Nagpur', label: 'Nagpur' },
                { value: 'Nashik', label: 'Nashik' },
                { value: 'Patna', label: 'Patna' },
                { value: 'Pune', label: 'Pune' },
                { value: 'Surat', label: 'Surat' },
                { value: 'Visakhapatnam', label: 'Visakhapatnam' },
                { value: 'Others', label: 'Others' }
              ],
              



     
            // Removed numberOptions as we are using min/max on input type="number"
        },
        recommendations: {
            title: 'Recommended Health Coverage',
            basedOn: 'Based on your profile:',
            ageGroup: 'Age Group',
            cityType: 'City Type',
            preExisting: 'Pre-Existing Conditions',
            suggestedCoverage: 'Suggested Coverage Amount',
            disclaimer: 'These recommendations are indicative. Please consult with an insurance advisor for personalized advice.'
        }
    },
};

export default HealthInsuranceFormTranslations;